// eslint-disable-next-line no-restricted-imports
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export type RedirectConfig = {
  from: string;
  to: ((params?: any) => string) | (() => string);
};

export const Redirect = ({ redirect }: { redirect: RedirectConfig }) => {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const getRedirectPath = () => {
    if (typeof redirect.to === 'function') {
      // Check if the route has parameters
      if (redirect.from.includes(':')) {
        // Has params, pass them to the function
        return redirect.to(params);
      } else {
        // No params, call function without arguments
        return (redirect.to as () => string)();
      }
    }
    // Handle legacy path function redirects
    return (redirect.to as any)(params);
  };

  const redirectPath = getRedirectPath();

  // Parse the path to separate pathname and search params
  const [pathname, existingSearch] = redirectPath.split('?');

  // Combine existing search params from redirect with current search params
  const currentSearch = searchParams.toString().replace('showTab', 'tab');
  const finalSearch = existingSearch
    ? currentSearch
      ? `${existingSearch}&${currentSearch}`
      : existingSearch
    : currentSearch;

  return (
    <Navigate
      to={{
        pathname,
        search: finalSearch,
      }}
      replace
    />
  );
};
